import request from '../../utils/request';

export async function getCxmHealthStatisticListRequest(params) {
  return request({
    url: 'cxmHealthStatistic/list',
    method: 'post',
    headers: 'json',
    params,
  });
}

export async function exportCxmHealthStatisticRequest(params) {
  return request({
    url: 'cxmHealthStatistic/download',
    method: 'post',
    headers: 'json',
    params,
    responseType: 'blob',
  });
}

export async function getCxmHealthStatisticDetailRequest(stallId) {
  return request({
    url: 'cxmHealthStatistic/detail',
    method: 'get',
    headers: 'json',
    params: { stallId },
  });
}
